<script lang="ts">
	import {
		AdvancedCardV2,
		LabelV2,
		LabelListV2,
		ControlsContainer,
		Text,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	//Components
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import VirtualBooleanButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualBooleanButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import DeviceLabelList from 'src/components/Sidepanel/DeviceViews/DeviceLabelList.svelte';

	export let device: Device, statuses: VCInterfaceStatus[];

	$: ppmStatus = statuses.find((i) => /^(ppm)$/.test(i.role));
	$: muteStatus = statuses.find((i) => /^(mute_alarm)$/.test(i.role));
	$: backlightStatus = statuses.find((i) => /^(backlight_enable)$/.test(i.role));

	$: filteredStatuses = statuses.filter((i) =>
		/^(battery_percentage|current_temperature|current_humidity)$/.test(i.role),
	);
</script>

<DeviceLabelList labelList={filteredStatuses} />
<DeviceNotificationLabel deviceId={device?.id} />
{#if ppmStatus}
	<AdvancedCardV2 title={translateTemplateTitle(ppmStatus.vcName)}>
		<LabelListV2
			size="m"
			backgroundColor="--color-1"
			labelList={ppmStatus.labelList || []}
			slot="main"
			data-prevent-drawer-swipe
			data-prevent-sidepanel-swipe
			a11yProps={{ isInteractive: true }}
		/>
		<div slot="right">
			<LabelV2
				style="max-width: 100%;"
				size="l"
				value={translateTemplateTitle(ppmStatus.label || ppmStatus.value)}
				icon={ppmStatus.icon}
				iconColor={ppmStatus.iconColor}
			/>
		</div>
	</AdvancedCardV2>
{/if}

<div class="flex-full-height justify-content-end">
	{#if muteStatus}
		<ControlsContainer class="mt-s" color="color-0">
			<svelte:fragment slot="first">
				<VirtualBooleanButton
					isWide
					{device}
					componentID={muteStatus.id}
					value={muteStatus.event}
					icon={muteStatus.icon}
					useV2Components
				/>
				<Text styleType="controls-large" class="mt-s text-bold">
					{translateTemplateTitle(muteStatus.event ? 'Unmute' : 'Mute')}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
	{#if backlightStatus}
		<ControlsContainer class="mt-s" color="color-0">
			<svelte:fragment slot="first">
				<VirtualBooleanButton
					isWide
					{device}
					componentID={backlightStatus.id}
					value={backlightStatus.event}
					icon={backlightStatus.icon}
					useV2Components
				/>
				<Text styleType="controls-large" class="mt-s text-bold">
					{translateTemplateTitle(`backlight_${backlightStatus.event ? 'off' : 'on'}`)}</Text
				>
			</svelte:fragment>
		</ControlsContainer>
	{/if}
</div>
